import { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import flow from 'lodash/flow';

import withAlexaLinking from '../../../decorators/withAlexaLinking';

import { openLinkWithAlexaDialog } from '../../../actions/dialog';
import { logAccountActivity } from '../../../actions/logging';

import {
  USER_REGISTRATION_DIALOG_LINK_ALEXA,
  USER_REGISTRATION_DIALOG_LISTEN_ALEXA,
} from '../../../constants/localizations/userRegistration';
import account from '../../../constants/analytics/categoryActionLabel/account';
import { LocationAndLocalizationContext } from '../../../providers/LocationAndLocalizationProvider';
import Hint from './Hint';

export class LinkWithAlexaHint extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      openLinkWithAlexaDialog: PropTypes.func.isRequired,
      logAccountActivity: PropTypes.func.isRequired,
    }),
    onLinkWithAlexaClick: PropTypes.func.isRequired,
    isAlexaLinkingEnabled: PropTypes.bool,
    isAlexaLinked: PropTypes.bool,
    className: PropTypes.string,
  };

  static contextType = LocationAndLocalizationContext;

  constructor(props) {
    super(props);
    this.linkYourAccount = this.linkYourAccount.bind(this);
  }

  linkYourAccount() {
    const { actions, onLinkWithAlexaClick } = this.props;
    actions.logAccountActivity(account.actions.click, [
      account.labels.linkAlexa,
    ]);
    actions.openLinkWithAlexaDialog();
    onLinkWithAlexaClick();
  }

  render() {
    const { isAlexaLinked, isAlexaLinkingEnabled, className } = this.props;
    const { getLocalizedText } = this.context;

    if (!isAlexaLinkingEnabled || isAlexaLinked) {
      return null;
    }

    return (
      <Hint
        className={className}
        text={getLocalizedText(USER_REGISTRATION_DIALOG_LISTEN_ALEXA)}
        link={{
          label: getLocalizedText(USER_REGISTRATION_DIALOG_LINK_ALEXA),
          onClick: this.linkYourAccount,
        }}
      />
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        openLinkWithAlexaDialog,
        logAccountActivity,
      },
      dispatch,
    ),
  };
}
export default flow(
  connect(null, mapDispatchToProps),
  withAlexaLinking,
)(LinkWithAlexaHint);
